import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {BrickSnake2000} from "../BrickSnake2000";
import {gsap} from "gsap";
import {BrickSnake2000Sound} from "../sound/BrickSnake2000Sound";
import {
    SimplePresentation, SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {LocalPresentation} from "../runnerpresentations/LocalPresentation";
import {FreeSpinsIntro, FreeSpinsRestoreIntro} from "../runnerpresentations/freespin/FreesSpinIntro";
import {FreeSpinUpgrade} from "../runnerpresentations/freespin/FreeSpinUpgrade";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {BrickSnake2000WildSymbol} from "../reels/symbols/WildSymbol";
import {BrickSnake2000Symbol} from "../reels/symbols/BrickSnake2000Symbol";
import {MultipleSymbolsThing} from "../reels/BrickSnake2000FreespinsReelView";
import {singelEffectsPlayer} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {syncBuiltinESMExports} from "module";

export class BrickSnake2000FreespinsIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    public start(flowStateController:FlowStateController) {
        const presentations:SimplePresentation[] = [
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.restorePadding(controller),
                                  ()=>{return true},
                                  "restorePadding"),
            new FreeSpinsRestoreIntro(),
            new FreeSpinUpgrade(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.doFreespinZeroBet(controller),
                                  ()=>{return true},
                                  "doFreespinZeroBet")
        ];

        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "Fs intro runner ");

    }

    private restorePadding(controller:SimplePresentationRunnerController) {
       gsap.timeline().add(() => {}).add(() => controller.finish(), '>0.5');
    }

    private doFreespinZeroBet(controller:SimplePresentationRunnerController) {
        const tl = gsap.timeline();
        tl.add(() => {
            BrickSnake2000.apiPlugin.betHandler.zeroBet();
        });
        tl.add(() => {
            BrickSnake2000.soundPlayer.playLoopingSound(BrickSnake2000Sound.REEL_SPINNING_FS);
            BrickSnake2000.freespinsReelView.clearDeadSneks();
        });
        BrickSnake2000.baseGameReelView.getAllSymbolsActually().filter(sym => sym.reelPosition == -1)
                                                               .forEach(sym => sym.visible = true);

        if (BrickSnake2000.model.data.mode != GameMode.NORMAL) {
            BrickSnake2000.model.stickyFreespinPosition().forEach((pos) => {
                BrickSnake2000.freespinsReelView.getReelModel(pos.reelID, pos.reelPosition).markAsSticky();
            })
        }
        const isFastSpins = BrickSnake2000.apiPlugin.settings.get(APISetting.FAST_SPIN);
        const stopDelay = isFastSpins ? '<' : '<0.023';
        const startTl = gsap.timeline();
        for (let row = 0; row < 5; row++) {
            for (let reel = 0; reel < 5; reel++) {
                const singleReel = BrickSnake2000.freespinsReelView.getReelModel(reel, row)
                const visibleSymbol = singleReel.getVisibleSymbol();
                if (!singleReel.isSticky) {
                    startTl.add(singleReel.start(), stopDelay);
                } else if ((<BrickSnake2000Symbol>visibleSymbol).symbolName == "W") {
                    const symbol = <BrickSnake2000WildSymbol>visibleSymbol;
                    startTl.add(() => {symbol.setWaiting()}, stopDelay);
                    // if its undefined it means we restore with that its not the first spin
                    if (BrickSnake2000.model.gameData == undefined ||
                        BrickSnake2000.model.gameData.freespinsPlayed > 0) {
                        startTl.add(symbol.revive(), '<');
                        startTl.add(() => {BrickSnake2000.soundPlayer.playSound("snekNewRound")}, '<');
                    }
                } else if (visibleSymbol instanceof MultipleSymbolsThing) {
                    singleReel.removeNonHeads();
                    const symbols = <BrickSnake2000WildSymbol[]>visibleSymbol.getSymbols();
                    startTl.add(() => {this.fixSnakeHeadOverlap(symbols)});
                    startTl.add(() => {symbols.forEach((sym) => sym.setWaiting())}, stopDelay);
                    if (BrickSnake2000.model.gameData == undefined ||
                        BrickSnake2000.model.gameData.freespinsPlayed > 0) {
                        startTl.add(symbols.map((sym) => sym.revive()), '<');
                        startTl.add(() => {BrickSnake2000.soundPlayer.playSound("snekNewRound")}, '<');
                    }
                }
            }
        }
        tl.add(startTl);

        tl.add(() => { controller.finish() }, '>');
    }

    // correct snakes being rotated the same way
    private fixSnakeHeadOverlap(symbols:BrickSnake2000WildSymbol[]) {
        if (symbols.length < 2)
            return;

        if (symbols[0]?.rotation == symbols[1]?.rotation) {
            const sym1Rot = symbols[0].rotation
            symbols[1].setRotation(sym1Rot == 0 ? Math.PI : sym1Rot + Math.PI, "right");
            if (symbols.length == 3)
                symbols[2].setRotation(sym1Rot == 0 ? Math.PI * 0.5 : sym1Rot + Math.PI * 0.5, "right");

        } else if (symbols[0]?.rotation == symbols[2]?.rotation) {
            const sym1Rot = symbols[0].rotation
            symbols[2].setRotation(sym1Rot == 0 ? Math.PI : sym1Rot + Math.PI, "right");
            if (symbols.length == 3)
                symbols[1].setRotation(sym1Rot == 0 ? Math.PI * 0.5 : sym1Rot + Math.PI * 0.5, "right");

        } else if (symbols[1]?.rotation == symbols[2]?.rotation) {
            const sym1Rot = symbols[1].rotation
            symbols[2].setRotation(sym1Rot == 0 ? Math.PI : sym1Rot + Math.PI, "right");
            if (symbols.length == 3)
                symbols[0].setRotation(sym1Rot == 0 ? Math.PI * 0.5 : sym1Rot + Math.PI * 0.5, "right");
        }
    }
}